module.exports = function() {
  return new Worker(__webpack_public_path__ + "1a0318159d80430ee486.worker.js");
};